module.exports = __webpack_public_path__ + "img/ability-lab.ee4962df.svg";